import { Box, BoxProps } from '@chakra-ui/react';

export const WhiteCard = (props: BoxProps) => (
  <Box bgColor='white' border='1px solid' borderColor='gray.200' borderRadius='base' {...props} />
);
